/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable object-curly-newline */
/* eslint-disable react/require-default-props */
import React, { useState, useRef } from 'react';
import {
  Dialog, DialogContent, DialogActions, Button, Typography, IconButton,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import FileUploadIcon from '@mui/icons-material/FileUpload';

interface UploadDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: (file: File) => void;
  title?: string;
  subtitle?: string;
}

export default function UploadDialog({
  open,
  onClose,
  onUpload,
  title = 'Upload Document',
  subtitle = 'Select a PDF file to upload.',
}: UploadDialogProps): JSX.Element {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0] || null;
    setSelectedFile(file);
  };

  const handleUpload = (): void => {
    if (selectedFile) {
      onUpload(selectedFile);
      setSelectedFile(null);
      onClose();
    }
  };

  const handleClose = (): void => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px 0' }}>
        <Typography variant='h6' style={{ fontWeight: 600 }}>{title}</Typography>
        <IconButton onClick={handleClose} size='small'>
          <ClearIcon />
        </IconButton>
      </div>
      <DialogContent>
        <Typography variant='body2' style={{ color: '#6B7280', marginBottom: '16px' }}>{subtitle}</Typography>
        <div
          style={{
            border: '2px dashed #D1D5DB',
            borderRadius: '8px',
            padding: '32px',
            textAlign: 'center',
            cursor: 'pointer',
            backgroundColor: selectedFile ? '#F0FDF4' : '#FAFAFA',
          }}
          onClick={() => fileInputRef.current?.click()}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter') fileInputRef.current?.click(); }}
        >
          <FileUploadIcon style={{ fontSize: '40px', color: '#9CA3AF', marginBottom: '8px' }} />
          <Typography variant='body2' style={{ color: '#6B7280' }}>
            {selectedFile ? selectedFile.name : 'Click to select a PDF file'}
          </Typography>
          <input
            ref={fileInputRef}
            type='file'
            accept='.pdf'
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: '8px 24px 16px' }}>
        <Button onClick={handleClose} style={{ color: '#6B7280' }}>Cancel</Button>
        <Button
          onClick={handleUpload}
          variant='contained'
          disabled={!selectedFile}
          style={{
            backgroundColor: selectedFile ? '#00CFA1' : '#E5E7EB',
            color: selectedFile ? '#fff' : '#9CA3AF',
            textTransform: 'none',
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
